import { onEvent } from '../../util/domutils'; // eslint-disable-line import/named
import { loadContent, fetchOptionsGet } from '../../util/fetchutils'; // eslint-disable-line import/named
import { initFlyout } from '../../components/flyoutUnderHeader';
import { searchStores } from '../../components/searchStores';
import { addBackToTopHandler } from '../../components/backToTop';

const SELECTORS = {
  PANE: '.product-detail__stock-check__pane',
  FORM: '.product-detail__stock-check__form',
  RESULT: '.product-detail__stock-check__result',
  ATTRIBUTE: '.product-detail__stock-check__form__attribute',
  SWATCH_ICON: '.product-detail__stock-check__form__fields__background',
  DETECT_LOCATION: '.product-detail__stock-check__form .detect-location',
  NEAREST_STOCKED_FORM: '.product-detail__stock-check__result__nearest-stocked-check',
  STORE_LABEL: '.product-detail__stock-check__result__row--store',
  ACTIVE_STORE_LABEL: '.product-detail__stock-check__result__row--store.active',
  BACK_TO_TOP_BTN: '.product-detail__stock-check__result__table__back-to-top',
  STORECHECK_LINK: '.product-detail__stock-check__link',
};

const initStockCheckFlyout = () => {
  const stockCheckPane = document.querySelector(SELECTORS.PANE);

  if (stockCheckPane) {
    if (document.querySelector('.product-set-detail .set-items') || document.querySelector('.js-onestock-pdp')) {
      const stockCheckPanes = document.querySelectorAll(SELECTORS.PANE);
      stockCheckPanes.forEach((fc) => {
        initFlyout(fc);
        if (fc.getAttribute('initialized') !== 'true') {
          fc.setAttribute('initialized', 'true');
        }
      });
    } else {
      initFlyout(stockCheckPane);
      if (stockCheckPane.getAttribute('initialized') !== 'true') {
        stockCheckPane.setAttribute('initialized', 'true');
      }
    }
  }

  onEvent(document, 'click', SELECTORS.STORECHECK_LINK, async (e) => {
    let googleScriptTag;
    const linkHolder = document.querySelector('.countryField-holder');
    // eslint-disable-next-line prefer-template
    const googleApi = document.querySelector('script[src="' + e.delegateTarget.dataset.googleApi + '"]');
    if (!googleApi && e.delegateTarget.dataset.googleApi !== 'null') {
      googleScriptTag = document.createElement('script');
      googleScriptTag.setAttribute('src', e.delegateTarget.dataset.googleApi);
      document.head.appendChild(googleScriptTag);
    }
    if (linkHolder) {
      if (document.querySelector('.product-set-detail .set-items')) {
        const linkHolders = document.querySelectorAll('.countryField-holder');
        linkHolders.forEach(async (linkHoldr) => {
          const stockUrl = linkHoldr.dataset.url;
          if (linkHoldr.innerHTML.length <= 0) {
            const response = await fetch(stockUrl, fetchOptionsGet());
            const content = await response.text();
            linkHoldr.innerHTML = content;
          }
        });
      } else {
        const stockUrl = linkHolder.dataset.url;
        if (linkHolder.innerHTML.length <= 0) {
          const response = await fetch(stockUrl, fetchOptionsGet());
          const content = await response.text();
          linkHolder.innerHTML = content;
        }
      }
    }
  });
};

const initAttrSelect = () => {
  const swatchIcon = document.querySelector(SELECTORS.SWATCH_ICON);

  if (swatchIcon) {
    onEvent(document, 'change', SELECTORS.ATTRIBUTE, async (e) => {
      const attrVal = e.delegateTarget.selectedOptions[0];

      if (attrVal && attrVal.dataset.swatchUrl) {
        swatchIcon.style.backgroundImage = `url("${attrVal.dataset.swatchUrl}")`;
      }
    });
  }
};

const handleStoreSelect = () => {
  onEvent(document, 'click', SELECTORS.STORE_LABEL, async (e) => {
    document.querySelectorAll(SELECTORS.ACTIVE_STORE_LABEL).forEach((label) => {
      label.classList.remove('active');
    });

    const target = e.delegateTarget;
    target.classList.add('active');
  });
};

const initSearch = () => {
  const resultContainer = document.querySelector(SELECTORS.RESULT);

  if (resultContainer && resultContainer.getAttribute('initialized') !== 'true') {
    onEvent(document, 'click', SELECTORS.DETECT_LOCATION, async (e) => {
      e.preventDefault();

      const trigger = e.delegateTarget;
      const { form } = trigger;
      const content = await searchStores(form, trigger);

      resultContainer.innerHTML = content;
    });

    onEvent(document, 'submit', SELECTORS.FORM, async (e) => {
      e.preventDefault();

      const form = e.delegateTarget;
      const content = await searchStores(form);

      form.parentElement.nextElementSibling.innerHTML = content;

      addBackToTopHandler(SELECTORS.BACK_TO_TOP_BTN);

      handleStoreSelect();
    });

    onEvent(document, 'submit', SELECTORS.NEAREST_STOCKED_FORM, async (e) => {
      e.preventDefault();

      const { content } = await loadContent(e.delegateTarget);

      resultContainer.innerHTML = content;
    });

    resultContainer.setAttribute('initialized', 'true');
  }

  // The buttons are rendered disabled to prevent the form from being submitted without AJAX,
  // resulting in a partial page being rendered
  document.querySelectorAll(`${SELECTORS.FORM} button`).forEach((button) => {
    button.disabled = false;
  });
};

export default () => {
  initStockCheckFlyout();
  initAttrSelect();
  initSearch();
};
